import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React, { useState } from "react";
import axiosConfig from "../../axiosConfig";
import { LoadingButton } from "@mui/lab";

type EditPermissionProps = {
  id: any;
  options: {};
  role: string;
  fetchData: () => void;
};

interface CheckedOptions {
  admin: boolean;
  checker: boolean;
}

const EditPermissionButton: React.FC<EditPermissionProps> = (props) => {
  const [open, setOpen] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [checkedOptions, setCheckedOptions] = useState<Partial<CheckedOptions>>(
    { ...props.options }
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setCheckedOptions((prevData) => ({
      ...prevData,
      [name]: checked,
    }));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setCheckedOptions({ ...props.options });
    setOpen(false);
  };

  const handleSubmit = async () => {
    setDisableButton(true);
    await axiosConfig({
      method: "patch",
      url: "/users/update-roles",
      data: {
        ...checkedOptions,
        id: props.id,
      },
    }).then(async (res) => {
      if (res.status === 200) {
        await props.fetchData();
      }
    });
    setDisableButton(false);
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button
        variant="contained"
        disableElevation={true}
        size="small"
        sx={{ minWidth: "20px", marginRight: "10px" }}
        onClick={handleClickOpen}
      >
        <AddIcon sx={{ width: "30px" }} />
      </Button>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"ロールを編集する"}</DialogTitle>
        <DialogContent>
          <FormGroup>
            {props.role === "社員" && (
              <FormControlLabel
                control={
                  <Checkbox
                    name="admin"
                    disabled={disableButton}
                    checked={checkedOptions.admin}
                    onChange={handleChange}
                  />
                }
                label="管理者"
              />
            )}
            <FormControlLabel
              control={
                <Checkbox
                  name="checker"
                  disabled={disableButton}
                  checked={checkedOptions.checker}
                  onChange={handleChange}
                />
              }
              label="チェック担当"
            />
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{ fontWeight: "bold" }}
            disabled={disableButton}
          >
            キャンセル
          </Button>
          <LoadingButton
            onClick={handleSubmit}
            variant="contained"
            autoFocus
            sx={{ paddingX: "30px" }}
            disabled={disableButton}
            loading={disableButton}
          >
            登録
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default EditPermissionButton;
